import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { POST_DOC_MEMBERSHIP_BATCH_QUIT_VALIDATE_API, POST_DOC_MEMBERSHIP_BATCH_QUIT_API } from "@apis/apiPath";

const useDocMembershipBatchQuitApi = () => {
	const Ajax = useAjax();

    // 驗證會員是否可申請退會
	const postDocMembershipBatchQuitValidateApi = useCallback(
		async params => {
			return await Ajax.post(POST_DOC_MEMBERSHIP_BATCH_QUIT_VALIDATE_API, params);
		},
		// eslint-disable-next-line
		[]
	);

    // 會籍批次終止申請書
	const postDocMembershipBatchQuitApi = useCallback(
		async params => {
			return await Ajax.post(POST_DOC_MEMBERSHIP_BATCH_QUIT_API, params);
		},
		// eslint-disable-next-line
		[]
	);

	return {
		postDocMembershipBatchQuitValidateApi,
		postDocMembershipBatchQuitApi,
	};
};

export default useDocMembershipBatchQuitApi;
